import React from 'react';

import IconType from '../IconType';
import SVGIcon from '../SVGIcon';

const CSS = require('./CheckmarkIcon.module.scss');

type CheckmarkIconProps = {
  variant?:
    | 'jade'
    | 'pink'
    | 'warning'
    | 'success'
    | 'error'
    | 'inbetween-gray'
    | 'light-gray';
} & IconType;

function CheckmarkIcon({ variant, ...props }: CheckmarkIconProps) {
  return (
    <SVGIcon {...props} size={props.size ?? 24} viewBox="0 0 24 24">
      <path
        d="M19.2332318,4.63721535 C19.7290646,4.15686008 20.5204213,4.16940708 21.0007766,4.66523985 C21.4811319,5.16107261 21.4685849,5.95242938 20.9727521,6.43278465 L8.58610078,18.4327846 C8.04714465,18.9549172 7.17283836,18.8878494 6.71982468,18.2896231 L2.68760374,12.964882 C2.27083692,12.4145214 2.37913605,11.6305098 2.92949661,11.213743 C3.47985717,10.7969762 4.26386881,10.9052753 4.68063562,11.4556358 L7.86011968,15.655 L19.2332318,4.63721535 Z"
        data-variant={variant}
        className={CSS.Checkmark}
      />
    </SVGIcon>
  );
}

export default CheckmarkIcon;
